import { useMemo } from 'react'
import { doc } from 'firebase/firestore'
import { useDocumentData } from 'react-firebase-hooks/firestore'
import { firebase_firestore } from '../../../common/firebaseConfig'
import { Alert } from '../../../contexts/ApplicationSuiteProvider'

export const useExitTradingPlan = (
  exitTradingPlanId: string | undefined
): [Alert | undefined, boolean] => {
  const exitTradingPlanDocRef = useMemo(() => {
    return exitTradingPlanId ? doc(firebase_firestore, 'tradingPlans', exitTradingPlanId) : null
  }, [exitTradingPlanId])

  const [exitTradingPlan, loading] = useDocumentData(exitTradingPlanDocRef as any)

  return [exitTradingPlan as Alert | undefined, loading]
}
